import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';

import SubmitButton from '../common/SubmitButton';
import Alerts from '../common/Alerts';
import Translation from '../common/Translation';
import CancelButton from '../common/CancelButton';
import Input from '../common/Input';
import Role from '../../entities/role';
import { nameofFactory } from '../../helpers/nameOfFactory';
import * as enums from '../../common/enums';
import DropDownMultiSelect from '../common/DropDownMultiSelect';
import { BaseDetailProps } from '../common/types/baseDetail';

const nameof = nameofFactory<Role>();


export interface RoleDetailProps extends BaseDetailProps<Role>, RoleDetailStateProps {
    headerText: string;
}

export interface RoleDetailStateProps {
    lang: string;
}

class RoleDetail extends Component<RoleDetailProps> {
    handleOnSubmit = (values: object) => {
        this.props.submitAction(values as Role);
    };

    handleOnCancel = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.preventDefault();

        this.props.cancelAction();
    };

    translatedFormValidation = (values: object) => {
        const { t } = this.props;

        const typedValues = values as Role;
        const errors: Partial<Record<keyof Role, string>> = {};

        if (!typedValues.name) {
            errors.name = t('NameIsRequired');
        }

        return errors;
    };

    render() {
        const { initialValues, headerText, cancelAction } = this.props;

        return (
            <div>
                <div className="content-header">
                    <h1>{headerText}</h1>
                </div>
                <div className="content-wrapper">
                    <Alerts />
                    <div className="panel card col-xs-12 col-sm-6">
                        <Form
                            validate={this.translatedFormValidation}
                            onSubmit={this.handleOnSubmit}
                            initialValues={initialValues}
                            render={({ handleSubmit, form }) => (
                                <form className="k-form" onSubmit={handleSubmit}>
                                    <label className="k-form-field" htmlFor={nameof('name')}>
                                        <span>
                                            <Translation tKey="Name" />
                                        </span>
                                        <Field name={nameof('name')} component={Input} />
                                    </label>
                                    <label className="k-form-field" htmlFor={nameof('permittedModules')}>
                                        <span>
                                            <Translation tKey="PermittedModules" />
                                        </span>
                                        <Field
                                            name={nameof('permittedModules')}
                                            component={DropDownMultiSelect}
                                            textField="text"
                                            dataSource={enums.CAMPRO_MODULES}
                                        />
                                    </label>

                                    <div className="footer">
                                        <SubmitButton loading={form.getState().submitting}>
                                            <Translation tKey="Save" />
                                        </SubmitButton>
                                        <CancelButton onClick={this.handleOnCancel}>
                                            <Translation tKey="Cancel" />
                                        </CancelButton>
                                    </div>
                                </form>
                            )}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any): RoleDetailStateProps => {
    return {
        lang: state.app.lang,
    };
};

export default connect(mapStateToProps)(RoleDetail);
